import { Cookies } from 'react-cookie';

import { PestsVsTracesChartData } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getPestsVsTracesChart = async (slug: string, start_date: string, end_date: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`api/v1/encounters/charts/pest_vs_traces_per_day/${slug}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      start_date,
      end_date,
    },
  });

  return data.data as PestsVsTracesChartData;
};
